import React from "react";

import { Grid } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";

import { useAppState } from "../../../../../context/StateContext";
import { ShiftTime } from "../../../../../models/shift.time";
import NewShift from "./components/NewShift";
import Shift from "./components/Shift";
import { Title } from "./styles";

interface Props {
  shiftTimes: ShiftTime[];
  onChange: (shiftTimes: ShiftTime[]) => void;
}

const ShiftTimes = (props: Props) => {
  const { shiftTimes = [], onChange } = props;
  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();

  const handleAddNewShift = () => {
    if (!currentUser?.id) return;

    const newShift: ShiftTime = {
      id: uuid() as unknown as number, // Temporary id
      weekDays: "1,2,3,4,5",
      weekDaysSplit: [1, 2, 3, 4, 5],
      firstStartsAt: "08:00:00",
      firstStopsAt: "17:00:00",
    };

    onChange([...shiftTimes, newShift]);
  };

  const handleUpdateShift = (shift: ShiftTime) => {
    const auxShiftTimes = _.cloneDeep(shiftTimes);

    const shiftIndex = auxShiftTimes.findIndex((auxShift) => auxShift?.id === shift?.id);

    if (shiftIndex !== -1) {
      auxShiftTimes[shiftIndex] = shift;
      onChange(auxShiftTimes);
    }
  };

  const handleRemoveShift = (shiftId?: number) => {
    if (!shiftId) return;

    const auxShiftTimes = _.cloneDeep(shiftTimes);

    const shiftIndex = auxShiftTimes.findIndex((auxShift) => auxShift?.id === shiftId);

    if (shiftIndex !== -1) {
      auxShiftTimes.splice(shiftIndex, 1);
      onChange(auxShiftTimes);
    }
  };

  const renderShifts = () => {
    if (!shiftTimes.length) return null;

    return shiftTimes?.map((shift, index) => (
      <Shift key={index} shift={shift} onChange={handleUpdateShift} onDelete={handleRemoveShift} />
    ));
  };

  return (
    <Grid container direction="row" xs={12} sm={12} md={10} spacing={2}>
      <Grid item xs={12}>
        <Title>{translate("shiftTimes")}</Title>
      </Grid>
      {renderShifts()}
      <NewShift addNewShift={handleAddNewShift} />
    </Grid>
  );
};

export default ShiftTimes;
